import axios from 'axios'
import { formatError } from '../error'

const URL = 'https://postal-api.codemind.com.br'
const GET_ADDRESS = `${URL}/postal_code`

export const requestAddress = async (postalCode) => {
  const response = axios.get(`${GET_ADDRESS}/${postalCode}`)
    .then((resp) => resp.data.data)
    .catch((error) => formatError(error))

  return response
}
